<template>
  <v-container>
    <div class="headline mb-2">{{$t('help.title')}}</div>
    <v-expansion-panel>
      <v-expansion-panel-content v-for="(faq,i) in help" :key="i">
        <div slot="header"><h3>{{faq.title}}</h3></div>
        <v-card>
          <v-card-text v-html="faq.text">
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-container>
</template>

<script>
import Roles from '../../mixins/Roles'

export default {
  mixins: [Roles],
  computed: {
    help () {
      let role = this.isAdmin ? 'admin' : (this.isStaff ? 'staff' : 'student')
      let helpFaq = this.$t(`help.${role}`).map(topic => {
        let topicText = this.$t(`help.topics.${topic}`)
        return {
          title: topicText[0],
          text: topicText.slice(1, topicText.length).join(' ')
        }
      })
      return helpFaq
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/help/HelpPage.vue